'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _filter2 = require('./internal/_filter');

var _filter3 = _interopRequireDefault(_filter2);

var _curry = require('./curry');

var _curry2 = _interopRequireDefault(_curry);

var _immutable = require('immutable');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function without(unwanted, subject) {
  unwanted = _immutable.Seq.Set(unwanted);
  return (0, _filter3.default)(function (value) {
    return !unwanted.includes(value);
  }, subject);
}

/**
 * Removes values in `unwanted` from `subject`.
 *
 * @example
 * const removeOne = without(Set.of(1));
 *
 * removeOne(Set.of(1, 2, 3)) // returns Set { 2, 3 }
 *
 *
 * @param  {Iterable} unwanted
 * @param  {Iterable} subject
 * @return {Iterable}
 */
exports.default = (0, _curry2.default)(without);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.3/without.js
// module id = 397
// module chunks = 0 1